import { takeLeading, put, call } from "redux-saga/effects";
import { TResult } from "../../../../sg-core";
import {
    IRequestFetchInitalAppContext,
    createSuccessFetchInitalAppContext,
    createFailureFetchInitalAppContext,
    requestInitalAppContext,
    createSuccessAppRolesAction,
} from "../actions/contextActions";

import { IContextService, IInitialContextData } from "../../services/contextService";
import { createFailureFetchCategories, createSuccessFetchCategories } from "../actions/categoryAction";
import { createSuccessFetchFormTypes } from "../actions/formActions";
import { createSuccessFetchPersons } from "../actions/personAction";
import { createSuccessCategoryPermissionAction } from "../actions/permissionActions";

const makeFetchInitialContextSaga = (contextService: IContextService) =>
    function* saga(action: IRequestFetchInitalAppContext) {
        try {
            const result: TResult<IInitialContextData> = yield call(contextService.getInitialData);
            if (result.isSuccess) {
                yield put(createSuccessFetchInitalAppContext(result.value));
                yield put(createSuccessFetchCategories(result.value.categores));

                yield put(createSuccessFetchFormTypes(result.value.formTypes));
                yield put(createSuccessFetchPersons(result.value.persons));

                //  yield put(createAppendToLocationList(result.value.locations));
                // yield put(createAppendToFacilityList(result.value.facilities));
                // yield put(createAppendToAreaList(result.value.areas));
                yield put(createSuccessCategoryPermissionAction(result.value.categoryPermissions));
                yield put(createSuccessAppRolesAction(result.value.appRoles, result.value.appParameters));
            } else {
                yield put(createFailureFetchInitalAppContext(result.isFailure ? result.error : new Error()));
            }
        } catch (e) {
            console.log({ e });
            yield put(createFailureFetchCategories(e as Error));
            yield put(createFailureFetchInitalAppContext(e as Error));
        }
    };

export default function create(contextService: IContextService) {
    return takeLeading(requestInitalAppContext, makeFetchInitialContextSaga(contextService));
}
